import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADD_AGENT = 'add agent'
export const NAME = 'name'
export const AGENTS = 'agents'
export const REDIRECT = 'Redirect'
export const NUMBER = 'number'
export const EDIT = 'edit'
export const COPY_LINK = 'copy link'
export const NO_LINK = 'no link'

export default {
  [PORTUGUESE]: {
    [ADD_AGENT]: 'Adicionar Agente',
    [NAME]: 'Nome',
    [AGENTS]: 'Agente',
    [REDIRECT]: 'Redirecionar',
    [NUMBER]: 'Número',
    [EDIT]: 'Editar',
    [COPY_LINK]: 'A cópia para a área de transferência foi bem sucedida!',
    [NO_LINK]: 'Sem link',
  },

  [ENGLISH]: {
    [ADD_AGENT]: 'Add Agent',
    [NAME]: 'Name',
    [AGENTS]: 'Agent',
    [REDIRECT]: 'Redirect',
    [NUMBER]: 'Number',
    [EDIT]: 'Edit',
    [COPY_LINK]: 'Copying to clipboard was successful!',
    [NO_LINK]: 'No link',
  },

  [SPANISH]: {
    [ADD_AGENT]: 'Agregar Agente',
    [NAME]: 'Nombre',
    [AGENTS]: 'Agente',
    [REDIRECT]: 'Redirigir',
    [NUMBER]: 'Número',
    [EDIT]: 'Editar',
    [COPY_LINK]: '¡Copiar al portapapeles fue exitoso!',
    [NO_LINK]: 'No link',
  },
}
